var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingWords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47689 20.8C8.4259 20.22 7.67529 19.1999 7.63236 18C7.56802 15.7601 9.24096 14.66 10.2277 13.1601C11.6433 11.0001 11.2571 9.66006 11.2571 9.66006C11.2571 9.66006 12.4368 10.28 13.1231 12.5801C13.3376 13.2601 13.3804 13.9401 13.3161 14.5801C13.2088 16.2001 12.4582 17.66 12.4582 17.66C12.4582 17.66 13.7666 17.4 14.1312 15.18C14.7317 15.7599 15.2893 16.6001 15.3538 17.4799C15.4611 19 14.4958 20.4 13.0374 21C15.5682 20.46 17.3699 18.46 17.9919 17C18.7854 15.16 18.571 13.52 18.4424 12.1C18.2708 10.16 19 8.71999 19 8.71999C19 8.71999 17.606 9.10002 16.5763 10.6799C16.1045 11.3999 15.9115 12.4599 15.9115 12.4599C15.9115 12.4599 16.0187 11.5199 15.3539 9.79995C14.689 8.11999 14.0885 7.51996 13.7238 6.27999C13.252 4.62 14.3028 3 14.3028 3C14.3028 3 10.1419 3.72 8.25447 7.09999C6.58152 10.1 7.26778 11.9 7.26778 11.9C7.26778 11.9 6.55999 11.28 6.19538 10.42C5.83078 9.56002 5.91651 8.77988 5.91651 8.77988C5.91651 8.77988 2.95663 11.8199 4.39361 15.6399C5.35889 18.3201 7.22484 20.0799 9.47681 20.7999L9.47689 20.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingWords);
export default __webpack_public_path__ + "static/media/TrendingWords.9d4cf8c6e1ec5fe894e29b1b6c5d18fc.svg";
export { ForwardRef as ReactComponent };